import TimesheetStatusLabel from '@web/timesheets/TimesheetStatusLabel/TimesheetStatusLabel';

const TimesheetStatusLabelAngular = ({ status, isAssignee, isManager }) => (
  <TimesheetStatusLabel status={status} isAssignee={isAssignee} isManager={isManager} />
);

export default {
  ReactComponent: TimesheetStatusLabelAngular,
  bindings: {
    status: '<',
    isAssignee: '<',
    isManager: '<',
  },
};
